import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ReferenceBrandType } from '@1po/1po-bff-fe-spec/generated/catalog/references/common/model/ReferenceBrandType';
import { RedoIcon } from 'assets/icons';
import {
  addFavoriteTireBrandRequestSaga,
  getFavoriteBrandPreferences,
  removeFavoriteTireBrandRequestSaga,
  resetFavoriteTireBrandRequestSaga,
} from 'domains/user';
import { BrandCheckBox, SectionWrapper } from 'pages/SettingsPage/ProfilePage.styled';
import { Flex, Icon, Image, LightGreyButton, PaddingBox, Text } from 'UI';
import { tireBrandsData } from '../../TiresPage/TireSearch/TiresSearchbar/TireBrandsData';

export const TiresPreferencesSettings = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const favoriteBrandsList = useSelector(getFavoriteBrandPreferences);

  const addFavoriteBrand = (tireBrand: ReferenceBrandType) => {
    dispatch(addFavoriteTireBrandRequestSaga({ tireBrand }));
  };

  const removeFavoriteBrand = (tireBrand: ReferenceBrandType) => {
    dispatch(removeFavoriteTireBrandRequestSaga({ tireBrand }));
  };

  const resetFavoriteBrands = () => {
    dispatch(resetFavoriteTireBrandRequestSaga());
  };

  return (
    <PaddingBox py={25}>
      <SectionWrapper data-cy={'tires-preferences-page'}>
        <Flex direction={'column'} gap={25}>
          <Flex direction={'column'}>
            <Flex direction={'row'} justify={'space-between'} gap={15}>
              <Flex direction={'column'} gap={10}>
                <Text type="heading4">{t('settings.tires_preferences.title', 'Tires preferences')}</Text>
                <Text type="base">
                  {t('settings.tires_preferences.description_prompt', 'Select your favorite brands.')}
                </Text>
              </Flex>
              <LightGreyButton
                size={'large'}
                shape={'round'}
                onClick={resetFavoriteBrands}
                icon={<Icon IconComponent={RedoIcon} size={16} />}
                data-cy={'reset-selection-button'}
              >
                {t('settings.tires_preferences.action.reset_selection', 'Reset selection')}
              </LightGreyButton>
            </Flex>
            <Text type="base">
              {t(
                'settings.tires_preferences.description',
                'Only selected brands will be displayed when searching on RPartStore.',
              )}
            </Text>
          </Flex>
          <Flex wrap={'wrap'} gap={22} justify={'flex-start'}>
            {tireBrandsData.map((tireBrand) => {
              const isFavoriteBrand = favoriteBrandsList.includes(tireBrand.brand);
              return (
                <BrandCheckBox
                  key={tireBrand.brandId}
                  onClick={() =>
                    isFavoriteBrand ? removeFavoriteBrand(tireBrand.brand) : addFavoriteBrand(tireBrand.brand)
                  }
                  $isSelected={isFavoriteBrand}
                  data-cy={`tire-brand-${tireBrand.brand}`}
                >
                  <Image src={tireBrand.image} alt={'brand_image'} width={140} height={75} />
                </BrandCheckBox>
              );
            })}
          </Flex>
        </Flex>
      </SectionWrapper>
    </PaddingBox>
  );
};
